export interface Permission {
  permissao: boolean;
}

export interface UserPermission {
  idUsuario: string;
  nomeUsuario: string;
  grupos: UserGroup[];
  perfis: ProfileGroup[];
  chaves: KeysGroup[];
}

export interface PartnerPermission {
  telas: PartnerFields;
  funcionalidades: FunctionalitiesFields;
}

export interface ConsolidatedPortfolioPermission {
  freeToUse: boolean;
}

export interface CompliancePermission {
  assessores: number[];
}

interface FunctionalitiesFields {
  gerarOrdemClubes: number[];
  gerarOrdemIPO: number[];
  gerarOrdemPrevidencia: number[];
}

interface PartnerFields {
  geradorOrdens: number[];
  trading: number[];
}

export interface UserGroup {
  idSistema: number;
  nomeSistem: string;
  idGrupo: number;
  nomeGrupo: string;
}

interface ProfileGroup {
  idSistema: number;
  nomeSistem: string;
  idPerfil: number;
  nomePerfil: string;
}

interface KeysGroup {
  idSistema: number;
  nomeSistem: string;
  idChave: number;
  nomeChave: string;
}

export interface PermissionAccess {
  consolidated?: boolean;
  compliance?: boolean;
  screen?: boolean;
  trading?: boolean;
}

export interface PermissionGroup {
  user?: number[];
  partners?: number[];
  unicredBrb?: number[];
  compliance?: number[];
  idFilialParceiroIntranet?: number;
  consolidatedPortfolio?: boolean;
  trading?: number[];
  functionalities?: FunctionalitiesFields;
}

export type UserPermissions = PermissionGroup & { permissionAccess: PermissionAccess };

export class TokenExpiredError extends Error {
  constructor() {
    super('Token expired');
  }
}
